import ReplyIcon from "@mui/icons-material/Reply";
import {
  Alert,
  AppBar,
  Box,
  Button,
  IconButton,
  Snackbar,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import AgentDetails from "./playerProfileSections/AgentDetails";
import CollegeExperience from "./playerProfileSections/CollegeExperience";
import PersonalDetails from "./playerProfileSections/PersonalDetails";
import ProfessionalExperience from "./playerProfileSections/ProfessionalExperience";
import GLeagueExperience from "./playerProfileSections/GLeagueExperience";
import HighSchoolDetails from "./playerProfileSections/HighSchoolDetails";
import ClubPrograms from "./playerProfileSections/ClubPrograms";
import InternationalTeamExperience from "./playerProfileSections/InternationalTeamExperience";
import HSEventsAndRankings from "./playerProfileSections/HSEventsAndRankings";
import "../adminPreferences/AdminPreferences.css";
import { AppDataContext } from "../../common/appContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RouteConstants from "../../common/RouteConstants";

//... Optimized new routes import
import HSEventAndRankingViewUpdate from "./playerProfileSections/HSEventAndRankingViewUpdate";
import UpdateAgentDetails from "./playerProfileSections/UpdateAgentDetails";
import CollegeExperienceViewUpdate from "./playerProfileSections/CollegeExperienceViewUpdate";
import UpdatePlayerDetails from "./playerProfileSections/playerPersonalDetails/UpdatePlayerDetails";
import HighSchoolDetailsViewUpdate from "./playerProfileSections/HighSchoolDetailsViewUpdate";
import ClubProgramsViewUpdate from "./playerProfileSections/ClubProgramsViewUpdate";
import ProfessionalExperienceViewUpdate from "./playerProfileSections/ProfessionalExperienceViewUpdate";
import GLeagueExperienceViewUpdate from "./playerProfileSections/GLeagueExperienceViewUpdate";
import InternationalTeamExpViewUpdate from "./playerProfileSections/InternationalTeamExpViewUpdate";

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "100vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-moz-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-o-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-ms-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "linear-gradient(to bottom, #1d428a 230px, #f6f6f6 21px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  actionButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  exportToExcel: {
    border: "1px solid rgba(29, 66, 138, 0.5)",
    marginLeft: theme.spacing(1.25),
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5),
  },
  baseButton: {
    minWidth: "40px",
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  primaryButton: {
    backgroundColor: "#1d428a",
    color: "white",
    border: "1px solid #1d428a",
    "&:hover": {
      backgroundColor: "#16356f",
    },
  },

  secondaryButton: {
    backgroundColor: "#d32f2f",
    color: "white",
    border: "1px solid #d32f2f",
    "&:hover": {
      backgroundColor: "#b71c1c",
    },
  },
}));

export default function EditPlayerProfile() {
  const classes = useStyles();
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [playerData, setPlayerData] = useState({});
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { user, selectedEventId } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(params.eventId);

  //... Alert state holder
  const [alertType, setAlertType] = useState("success");

  const gridSectionStyles = {
    paperStyle: {
      marginTop: "15px",
    },
    gridRoot: {
      "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
        {
          outline: "none",
        },
    },
    gridConfig: {
      pageSize: 10,
      rowHeight: 38,
      headerHeight: 35,
      autoHeight: true,
    },
    gridSectionTitle: {
      fontWeight: "500",
      color: "#1d428a",
      variant: "subtitle1",
    },
    gridActionButton: {
      marginTop: "8px",
      fontSize: "1.5rem",
      cursor: "pointer",
      color: "#1d428a",
      "&:hover": {
        borderRadius: "50%",
        backgroundColor: "#e4e4e4",
      },
    },
    gridCellClassName: "admin-pref-grid-cells",
    sectionTitlePadding: {
      padding: "10px 0px 0px 15px",
    },
    inputSectionPadding: {
      padding: "10px 15px 0px 15px",
      textAlign: "end",
    },
    dataGridPadding: {
      padding: "15px",
    },
    noRowsOverlay: {
      position: "absolute",
      marginTop: "82px",
      marginLeft: "45%",
    },
    cancelButton: {
      textTransform: "none",
      padding: "2px 2px",
      marginRight: "10px",
      minWidth: "20px !important",
      title: "Cancel",
      variant: "outlined",
      cancelIconColor: {
        color: "#c8102e",
      },
    },
    saveButton: {
      textTransform: "none",
      padding: "2px 2px",
      minWidth: "20px !important",
      title: "Save",
      variant: "contained",
    },
  };

  useEffect(() => {
    setEventId(params.eventId);
  }, [params.eventId]);

  useEffect(() => {
    PlayerProfileService.getPlayersProfileData(
      params.playerId,
      params.eventId,
      user?.loginID
    ).then((response) => {
      setPlayerData(response.data);
    });
  }, [eventId]);

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const viewPlayerProfile = () => {
    navigate(
      `/${params.eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${params.playerId}`
    );
  };

  return (
    <>
      <Box className={classes.bgBlue}>
        <AppBar position="static" className={classes.appbarBackground}>
          <Toolbar variant="dense">
            <Typography noWrap align="left" className={classes.title}>
              {/* Edit Player Profile | */}
              <span style={{ color: "#c8102e" }}> {playerData.playerName}</span>
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                columnGap: "5px",
              }}
            >
              <Button
                variant="outlined"
                className={`${classes.baseButton} ${classes.secondaryButton}`}
                startIcon={<ReplyIcon />}
                onClick={() =>
                  navigate(`/${params.eventId}${RouteConstants.PLAYER_LIST}`)
                }
              >
                Back
              </Button>
              <Button
                variant="outlined"
                title="View Player Profile"
                className={`${classes.baseButton} ${classes.primaryButton}`}
                startIcon={<VisibilityIcon />}
                onClick={() => viewPlayerProfile()}
                sx={{ marginLeft: "10px" }}
              >
                View
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            marginTop: "8px",
            height: "calc(100vh - 130px)",
            overflowY: "scroll",
            padding: "0px 10px 10px 10px",
          }}
        >
          <UpdatePlayerDetails
            playerID={params.playerId}
            playerData={playerData}
            user={user}
          />
          <UpdateAgentDetails
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={playerData.agent ? playerData.agent : []}
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <CollegeExperienceViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={playerData.college ? playerData.college : []}
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <HighSchoolDetailsViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={playerData.highSchool ? playerData.highSchool : []}
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <ClubProgramsViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={playerData.aauClub ? playerData.aauClub : []}
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <ProfessionalExperienceViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={
              playerData.intProfExperience ? playerData.intProfExperience : []
            }
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <GLeagueExperienceViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={
              playerData.gLeagueExperience ? playerData.gLeagueExperience : []
            }
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <InternationalTeamExpViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            gridPropsData={
              playerData.nationalIntExp ? playerData.nationalIntExp : []
            }
            styles={gridSectionStyles}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <HSEventAndRankingViewUpdate
            eventId={params.eventId}
            playerID={params.playerId}
            highSchoolEventsData={
              playerData.highSchoolEvents ? playerData.highSchoolEvents : []
            }
            rankingsData={playerData.ranking ? playerData.ranking : []}
            styles={gridSectionStyles}
            playerData={playerData}
            setAlert={setAlert}
            setAlertType={setAlertType}
            setAlertMessage={setAlertMessage}
            user={user}
          />
          <Snackbar
            open={alert}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={2000}
            onClose={handleAlertClose}
          >
            <Alert
              onClose={handleAlertClose}
              severity={alertType}
              sx={{ width: "100%" }}
            >
              {alertMessage}
            </Alert>
          </Snackbar>
        </Box>
      </Box>
    </>
  );
}
